var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.063,40.313c0.552,0,1-0.447,1-1V10.75c0-0.553-0.448-1-1-1h-8.851c-0.552,0-1,0.447-1,1v28.563c0,0.553,0.448,1,1,1 H29.063z M28.063,11.75v26.563h-6.851v-1.938h1.664c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1.664v-2h1.664c0.552,0,1-0.447,1-1 s-0.448-1-1-1h-1.664v-2h1.664c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1.664v-2h1.664c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1.664v-2h1.664 c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1.664v-2h1.664c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1.664V11.75H28.063z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.cf10a2184908f3924346a898c4fd5f67.svg";
export { ForwardRef as ReactComponent };